import { ViewportScroller } from '@angular/common';
import {
    Component, Input, AfterViewInit, OnInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';

import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';
import { getShowCountdown } from '@features/cms-render/infrastructure/state/cms-render.selectors';
import {
    CommonStylesRenderDirective,
} from '@features/cms-render/ui/directives/common-styles-render/common-styles-render.directive';
import { ContentSwitchRender } from '@features/cms-render/ui/render-blocks/switch-content/switch-content.models';

@Component({
    selector: 'switch-content',
    templateUrl: './switch-content.component.html',
    styleUrls: ['./switch-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchContentComponent extends CommonStylesRenderDirective implements OnInit, AfterViewInit, OnDestroy {
    @Input() public element: ContentItemTree;

    @Input() public hasLogoSections: boolean = false;

    public contentSwitch: ContentSwitchRender = { isContentAVisible: false, isContentBVisible: false };

    private readonly onDestroy$ = new Subject();

    private isOnTime: boolean;

    private showCountdown$;

    constructor(
        private readonly cdr: ChangeDetectorRef,
        private readonly store: Store,
        private readonly viewportScroller: ViewportScroller,
    ) {
        super();
    }

    public ngOnInit(): void {
        this.showCountdown$ = this.store.select(getShowCountdown(this.element.slug));
        super.setDefaultHostStyles();
        this.checkCountDown();
    }

    public ngAfterViewInit(): void {
        this.initListener();
    }

    public checkCountDown(): void {
        const pieceCountDown = this.searchCountDown(this.element);
        this.isOnTime = pieceCountDown?.settings?.general?.isOnTime;

        if (!!pieceCountDown) {
            this.contentSwitch.isContentAVisible = this.isOnTime ?? false;
            this.contentSwitch.isContentBVisible = !this.isOnTime;
        }
    }

    private searchCountDown(element: ContentItemTree): ContentItemTree {
        if (element.definitionId === 'piece-countdown') {
            return element;
        }

        for (let child of element.children) {
            const countDown = this.searchCountDown(child);
            if (!!countDown) {
                return countDown;
            }
        }
    }

    private initListener(): void {
        this.showCountdown$
            .pipe(
                filter((val) => val !== this.isOnTime),
                distinctUntilChanged(),
                takeUntil(this.onDestroy$)
            )
            .subscribe(val => {
                if (val) {
                    this.contentSwitch.isContentAVisible = true;
                    this.contentSwitch.isContentBVisible = false;
                } else {
                    this.contentSwitch.isContentBVisible = true;
                    this.contentSwitch.isContentAVisible = false;
                    this.viewportScroller.scrollToPosition([0, 0]);
                }

                this.isOnTime = val;
                this.cdr.detectChanges();
            });
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next(undefined);
        this.onDestroy$.complete();
    }
}
